export const UPDATE_DEMO_PREVIEW_PARAMS = 'UPDATE_DEMO_PREVIEW_PARAMS';
export const UPDATE_DEMO_MENU = 'UPDATE_DEMO_MENU';
export const UPDATE_DEMO_CARD_DETAILS = 'UPDATE_DEMO_CARD_DETAILS';
